import React from 'react';
import StepperV1, { StepV1Props, StepperV1Props } from 'ReactApp/Components/StepperV1/StepperV1';
import { priceFormatter } from 'ReactApp/Services/Formatters/PriceFormatter';
import { dateTimeFormatter } from 'ReactApp/Services/Formatters/DateTimeFormatter';
import { motion } from 'framer-motion';
import splitLine from 'ReactApp/Services/MotionHelpers/SplitLine';
import { ShowableProductCard } from 'ReactApp/Ddd/Aggregates/ShowableProductCard';
import { observer } from "mobx-react";

const sentence = {
    visible: {
        transition: {
            delay: 2,
            staggerChildren: 0.05,
            staggerDirection: 1,
        },
    },
}

type BuyViaDolyameV1Props = {
    productCard: ShowableProductCard
}

const BuyViaDolyameV1 = observer((props: BuyViaDolyameV1Props) => {

    let isVisible: boolean = false;
    let part: number;
    let remainingPart: number;
    let now: Date = new Date();

    let stepperV1Props: StepperV1Props = {
        isVisible: isVisible,
        title: 'Долями',
    };

    if (
        props.productCard.salePrice === null
        //     ||
        // props.productCard.salePrice.value <= 1000
    ) {
        return (
            <StepperV1 {...stepperV1Props} />
        );
    }

    part = Math.round(props.productCard.salePrice.value / 4);
    remainingPart = Math.round(props.productCard.salePrice.value - part);

    stepperV1Props.desc = 
        <>
            Оплата Долями:&nbsp;
            <motion.strong
                variants={sentence}
                initial="hidden"
                animate="visible"
            >
                {splitLine(priceFormatter.format(part))}
            </motion.strong> сегодня,&nbsp;
            <motion.strong
                variants={sentence}
                initial="hidden"
                animate="visible"
            >
                {splitLine(priceFormatter.format(remainingPart))}
            </motion.strong> потом
        </>;
    stepperV1Props.isVisible = true;

    stepperV1Props.steps = [...Array(4).keys()].map(v => {
        let step: StepV1Props = {
            title: 
                v === 0 
                    ? 'Сегодня' 
                    : dateTimeFormatter.asDayWithFullMonth(
                        new Date(now.setMonth(now.getMonth() + v))
                    ),
            subtitle: priceFormatter.format(part),
        };
        return step;
    });

    return (
        <StepperV1 {...stepperV1Props} />
    );

})

export default BuyViaDolyameV1;